<div class="page-content">
    <ngx-loading [show]="showSpinner"></ngx-loading>
    <div class="row justify-content-center">
        <div class="col-md-12">
            <div class="card">
                <div class="modal-header">
                    <h1>{{'documentsUpload.pageTitle' | translate}}</h1>
                    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="form-control-label">
                                    {{ "documentsGrid.typeOfConstancy" | translate }}
                                </label>
                                <select class="form-control form-select form-control-sm pt-0 pb-0 small-height"
                                    [(ngModel)]="documentProcess.constancyType">
                                    <option *ngFor="let type of constancyTypeKeys; let i = index"  
                                    [selected]="constancyType['C20']"
                                    [value]="type">{{constancyType[type]}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="form-control-label">
                                    {{
    "documentsGrid.numberOfConstancy" |
                                       translate
                                    }}
                                </label>
                                <input type="text" name="documentProcessConstancyNumber"
                                    class="form-control text-uppercase" (keydown.space)="$event.preventDefault();"
                                    [(ngModel)]="documentProcess.constancyNumber" />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="form-control-label">
                                    {{
    "documentsGrid.numberOfInscription" |
                                       translate
                                    }}
                                </label>
                                <input type="text" name="documentProcessRegistrationNumber"
                                    class="form-control text-uppercase" (keydown.space)="$event.preventDefault();"
                                    [(ngModel)]="documentProcess.registrationNumber" />
                            </div>
                        </div>
                        <div class="form-group col-12 m-0">
                            <label for="assignDataList" class="form-control-label">{{"documentsGrid.assignTo" | translate }}</label>
                            <input class="form-control" list="datalistOptions" id="assignDataList" placeholder="-Asignar a (*)-" #assignTo
                            (change)="onOptionsSelected($event)"  [(ngModel)]="selectedItem">
                    
                            <datalist id="datalistOptions">
                              <option *ngFor="let assign of documentProcessToOptions" [ngValue]="assign">
                                {{assign.firstName +", " + assign.lastName + "-" + assign.sintraId + " " + assign.textFlag}}</option>
                            </datalist>
                            <div class="invalid-feedback"> La asignación de documento es requerida.</div>
                        </div>
                        
                        <div class="table-top">
                            <app-button [title]="'documentsUpload.addPatientInvite' | translate"
                                (buttonClick)="addInviteAssignTo()" icon="fa-plus">
                            </app-button>
                        </div>

                    </div>
                    <div class="table-body" *ngIf="selected == true">
                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr class="table-names">
                                    <th>{{ "documentsGrid.tableAssingToName" | translate }}</th>
                                    <th>{{ "documentsGrid.tableAssingToEmail" | translate }}</th>
                                    <th>{{ "documentsGrid.tableAssingToSignature" | translate }}</th>
                                    <th>{{ "documentsGrid.tableAassingToRead" | translate }}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of documentProcessToAssigns; let i = index">
                                    <th>{{ item.firstName + ", " + item.lastName || item.name + ", " + item.lastName }}</th>
                                    <th>{{ item.Email }}</th>
                                    <th scope="col">
                                        <div class="form-check">
                                            <label class="form-check-label">
                                                <input id="signature" 
                                                    type="radio" 
                                                    value="1" 
                                                    name="radioSelector{{item.sintraId}}_{{item.isOrganization}}"
                                                    (change)="changeRadioSelector($event, item.sintraId, item.isOrganization)">
                                            </label>
                                        </div>
                                    </th>
                                    <th scope="col">
                                        <div class="form-check">
                                            <label class="form-check-label">
                                                <input id="read" 
                                                    type="radio" 
                                                    value="2" 
                                                    name="radioSelector{{item.sintraId}}_{{item.isOrganization}}"
                                                    checked
                                                    (change)="changeRadioSelector($event, item.sintraId, item.isOrganization)">
                                            </label>
                                        </div>
                                    </th>
                                    <th>
                                        <app-button icon="fa-trash" (click)="removeAssigned(item.sintraId, item.isOrganization)"
                                        [info]="translate.instant('usersModule.eliminateUserTitle')"></app-button>
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <file-container #fileContainer>
                        <filedescriptor [(fileDescriptorId)]="documentProcess.documentFile.fileDescriptorId"
                            fileColumnClass="col-md-12" maxSize="41943040"
                            fieldLabel="{{ 'documentsUpload.uploadTitle' | translate }}" isEncrypted="false"
                            [showPreview]="true">
                        </filedescriptor>
                    </file-container>
                </div>
                <div class="modal-footer">
                    <label class="user-info mr-auto">{{"documentsGrid.flagText" | translate }}</label>
                    <app-button class="text-right" primary="true" [title]="'uploadFileDocument' | translate"
                        [info]='translate.instant("uploadFileDocument")' (buttonClick)="uploadDocument()"
                        [disable]="!isAbleToUpload()">
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</div>